import { createContext, useContext, useMemo } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import { getHome, updateHome } from "../../api/home";
import { getIntialValues, generatePayload } from "./helper";
import useToaster from "../../components/alert";
import Const from "../../utils/constant";

const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const toaster = useToaster();

  const getHomeQuery = useQuery({
    queryKey: ["home"],
    queryFn: getHome,
  });

  const updateHomeMutation = useMutation({
    mutationFn: updateHome,
    onSuccess: () => {
      toaster.success(Const.MESSAGES.SUCCESS, Const.MESSAGES.DATA_IS_UPDATED_SUCCESSFULLY);
      getHomeQuery.refetch();
    },
    onError: () => {
      toaster.error(Const.MESSAGES.FAILED, "Error updating homepage.");
    },
  });

  const initialValues = useMemo(() => {
    const homeData = getHomeQuery?.data?.data || {};
    return getIntialValues(homeData);
  }, [getHomeQuery?.data]);

  const handleSubmit = (values) => {
    const payload = generatePayload(values);
    updateHomeMutation.mutate(payload);
  };

  return (
    <PageContext.Provider
      value={{
        initialValues,
        handleSubmit,
        updateHomeQuery: updateHomeMutation,
      }}
    >
      {children}
    </PageContext.Provider>
  );
};

export const usePageProvider = () => {
  return useContext(PageContext);
};